import { render, staticRenderFns } from "./ContentCustomer.vue?vue&type=template&id=5076e5b4"
import script from "./ContentCustomer.vue?vue&type=script&lang=js"
export * from "./ContentCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports